const user = {
    name: 'Peter',
    surname: 'Linch',
    email: 'peter@inverbis.com',
    locale: 'es',
    subscription: {
        active: true,
    },
    timezone: '',
}

export default {
    me: () => [200, user],
    list: () => [200, Array.from({ length: 5 }, () => user)],
    update: ({ data }) => [200, JSON.parse(data)],
}
